import React, {Fragment, useState} from "react";
import { Modal, Card, Table, Button, Row, Col, Toast } from 'react-bootstrap';

const AsignacionMasiva = (props) => {
    
    // Con la sintaxis de desestructuración podemos extraer valores de propiedades en objetos 
    const { data, totalCasosAsignar, response, showToast, handleCloseToast} = props;
    
    return (
        <>
 <style type='text/css'>
    {`
    .btn-asignar-modal {
      background-color: #C14B49;
      color: #FFFFFF;
      width: 170px;
      padding:6px 0px 6px 0px;

    }
    .btn-asignar-modal:hover{
        background-color:  #F6897E;
        color: #FFFFFF;
    } 
    `}
    </style>
        <Modal {...props} size="xl" aria-labelledby="contained-modal-title-vcenter" centered>
            <Modal.Body>
                <div className="bg-secondary text-light rounded">
                    <h5 className="text-center p-2">{`Confirmar Asignación Masiva de Responsables (por regla - sin seguro)`}</h5>
                </div>
                { data && data.length > 0 ? 
                <Card className="mt-4 mb-2">
                    <Card.Body>                    
                        <Table striped hover>
                            <thead style={{ backgroundColor: '#4F517A', color: 'white' }}>
                                <tr>
                                    <th style={{ fontSize: '16px' }}>ID</th>
                                    <th style={{ fontSize: '16px' }}>Nombre Razón Social</th>
                                    <th style={{ textAlign: 'center', fontSize: '16px' }}>Casos por Asignar</th>                                    
                                </tr>
                            </thead>
                            <tbody>
                                {data && data.map((pre, index) => {
                                    return (
                                        <tr key={index}>
                                            <td>{pre.idResponsable}</td>
                                            <td>{pre.responsableGestion}</td>
                                            <td style={{ textAlign: 'center' }}>{pre.cantidad}</td>
                                        </tr>
                                    )
                                })}
                                <tr>
                                    <td></td>
                                    <td style={{ fontSize: '18px', fontWeight:'bold' }}>Total por Asignar:</td>
                                    <td style={{ textAlign: 'center', fontWeight:'bold' }}>{totalCasosAsignar}</td>
                                </tr>
                            </tbody>
                        </Table>                        
                    </Card.Body>
                </Card>
                : null }
                <Toast onClose={handleCloseToast} show={showToast} delay={3000} autohide >
                    <Toast.Header style={{ backgroundColor: response?.code === 1 ? '#4CAF50' : response?.code === 11 ? '#fc9d03' : 'red', color: 'white' }}>
                        <strong className="me-auto">{response?.code === 1 ? 'Respuesta Satisfactoria' : response?.code === 11 ? 'Atención!' : 'Error'}</strong>
                    </Toast.Header>
                    <Toast.Body>
                        {response ? response?.message : "Enviando ..."}
                    </Toast.Body>
                </Toast>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={props.onHide}>Cerrar</Button>
                <Button variant='asignar-modal' onClick={props.confirmarAsignacion}>Confirmar Asignación</Button>
            </Modal.Footer>
        </Modal>
    </>
    );
}

export default AsignacionMasiva;